import {
    IContato,
    IFiltroListarContatos,
} from "../../../Interfaces/Automacao/Audiencia/AudienciaInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarContatosFiltroService(
    requestBody: IFiltroListarContatos
) {
    return Service(
        Axios.post<Array<IContato>>(
            `/automacao/audiencia/listarcontatosfiltro`,
            requestBody
        )
    );
}

export async function VincularContatosService(
    idAudiencia: number,
    idContatos: Array<number>
) {
    return Service(
        Axios.post(
            `automacao/audiencia/vincularcontatoaudiencia?idAudiencia=${idAudiencia}`,
            idContatos
        )
    );
}

export async function DesvincularContatosService(
    idAudiencia: number,
    idContatos: Array<number>
) {
    return Service(
        Axios.post(
            `automacao/audiencia/desvincularcontatoaudiencia?idAudiencia=${idAudiencia}`,
            idContatos
        )
    );
}
